module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc",
    attrs: {
      "id": "toc"
    }
  }, [_c('p', {
    staticClass: "Title"
  }, [_vm._v("CONTENTS")]), _vm._v(" "), _c('div', {
    staticClass: "paraNoIndentH"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "tocpara1",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/07_prologue"
    }
  }, [_vm._v("PROLOGUE")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_intro"
    }
  }, [_vm._v("INTRODUCTION: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Helicopters")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocparaA"
  }, [_c('a', {
    attrs: {
      "href": "#/09_part01"
    }
  }, [_vm._v("FLYING LIFE ONE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Army 1968–1971")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/10_chapter01"
    }
  }, [_vm._v("1:   The Accidental Aviator")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/11_chapter02"
    }
  }, [_vm._v("2:   Chasing Buzzards")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('a', {
    attrs: {
      "href": "#/12_chapter03"
    }
  }, [_vm._v("3:   Engine Failure")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4:   The Playtex Club")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5:   First takeoff of the Day")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6:   Luck and Superstition")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7:   Survival Instruments")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8:   Tracers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9:   Army Night Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10:   Flares")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11:   Napalm")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12:   Last ’Nam Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocparaA"
  }, [_c('span', {
    attrs: {
      "href": "#/22_part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLYING LIFE TWO: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The National Guard 1972–1975")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13:   Truck Strike")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/24_chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14:   National Guard Night Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/52_chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15:   Tornados")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/53_chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16:   National Guard Summers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocparaA"
  }, [_c('span', {
    attrs: {
      "href": "#/54_part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLYING LIFE THREE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Marine Corps 1975–1973")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17:   Night Vision Goggles")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/56_chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18:   Marine Corps Night Flight")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/57_chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19:   Wires")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20:   Externals")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/59_chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21:   The Ritual")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/60_chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22:   Special Operations Capable")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/61_chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23:   Broken on a moroccan Beach")])]), _vm._v(" "), _c('p', {
    staticClass: "tocparaA"
  }, [_c('span', {
    attrs: {
      "href": "#/61i_part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FLYING LIFE FOUR: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The British Royal Navy 1983–1985")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/62_chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24:   Sand")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/63_chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25:   Introducing the Arctic to Captain Curtis")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/64_chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26:   Royal Navy Night Flight—the Difficult Valley")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/65_chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27:   Troop Lifting, with Night and Heavy Snow Showers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/66_chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28:   Long Flight Home")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29:   Sea Fog")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/68_chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30:   Day and Night Passengers")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31:   Final Flight with the Royal Navy")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara1"
  }, [_c('span', {
    attrs: {
      "href": "#/70_epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("EPILOGUE: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wall, 20 Years After")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara1"
  }, [_c('span', {
    attrs: {
      "href": "#/71_glossary",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("GLOSSARY")])]), _vm._v(" "), _c('p', {
    staticClass: "tocpara1"
  }, [_c('span', {
    attrs: {
      "href": "#/72_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e4ad02","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_toc.vue
// module id = 66
// module chunks = 0